import React from 'react';
import { TrendingUpIcon, AlertTriangleIcon } from 'lucide-react';
export function BudgetProgress({
  currentUsage,
  monthlyBudget,
  currentDay,
  daysInMonth
}) {
  const percentage = currentUsage / monthlyBudget * 100;
  const expectedPercentage = currentDay / daysInMonth * 100;
  const isOverBudget = percentage > expectedPercentage;
  return <div className="bg-white rounded-xl shadow-sm p-6 mb-6" data-id="element-72">
      <div className="flex items-start justify-between mb-4" data-id="element-73">
        <h2 className="text-lg font-semibold" data-id="element-74">Budget Progress</h2>
        {isOverBudget && <div className="flex items-center text-sm text-orange-600" data-id="element-75">
            <AlertTriangleIcon size={16} className="mr-1" data-id="element-76" />
            Above expected usage
          </div>}
      </div>
      <div className="mb-6" data-id="element-77">
        <div className="flex justify-between mb-2" data-id="element-78">
          <span className="text-sm text-gray-600" data-id="element-79">Current Usage</span>
          <span className="text-sm font-medium" data-id="element-80">
            {currentUsage.toLocaleString()}₫ / {monthlyBudget.toLocaleString()}₫
          </span>
        </div>
        <div className="relative" data-id="element-81">
          <div className="w-full bg-gray-200 rounded-full h-4" data-id="element-82">
            <div className={`h-4 rounded-full transition-all ${percentage > 90 ? 'bg-red-500' : percentage > 70 ? 'bg-yellow-500' : 'bg-green-500'}`} style={{
            width: `${Math.min(percentage, 100)}%`
          }} data-id="element-83"></div>
          </div>
          <div className="absolute top-0 h-4 border-l-2 border-blue-500" style={{
          left: `${expectedPercentage}%`
        }} data-id="element-84">
            <div className="absolute -top-6 left-0 transform -translate-x-1/2 text-xs text-blue-600 whitespace-nowrap" data-id="element-85">
              Expected
            </div>
          </div>
        </div>
        <div className="flex justify-between mt-2" data-id="element-86">
          <span className="text-xs text-gray-500" data-id="element-87">0₫</span>
          <span className="text-xs text-gray-500" data-id="element-88">
            {monthlyBudget.toLocaleString()}₫
          </span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4" data-id="element-89">
        <div className="bg-gray-50 rounded-lg p-4" data-id="element-90">
          <p className="text-sm text-gray-600 mb-1" data-id="element-91">Daily Average</p>
          <p className="text-xl font-bold" data-id="element-92">
            {(currentUsage / currentDay).toLocaleString()}₫
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-93">
            Target: {(monthlyBudget / daysInMonth).toLocaleString()}₫/day
          </p>
        </div>
        <div className="bg-gray-50 rounded-lg p-4" data-id="element-94">
          <p className="text-sm text-gray-600 mb-1" data-id="element-95">Projected Total</p>
          <p className={`text-xl font-bold ${currentUsage / currentDay * daysInMonth > monthlyBudget ? 'text-red-600' : 'text-green-600'}`} data-id="element-96">
            {(currentUsage / currentDay * daysInMonth).toLocaleString()}₫
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-97">
            {currentUsage / currentDay * daysInMonth > monthlyBudget ? 'Over budget' : 'Under budget'}
          </p>
        </div>
      </div>
    </div>;
}